var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "Save & Share",
        width: "500px",
        "before-close": _vm.close,
        "custom-class": "viq-share-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "viq-share" }, [
        _c(
          "div",
          { staticClass: "viq-share__field" },
          [
            _c("label", [_vm._v("Title")]),
            _vm._v(" "),
            _c("el-input", {
              attrs: { placeholder: "Give this a name..." },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "viq-share__field" },
          [
            _c("label", [_vm._v("Visibility")]),
            _vm._v(" "),
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.visibility,
                  callback: function ($$v) {
                    _vm.visibility = $$v
                  },
                  expression: "visibility",
                },
              },
              [
                _c("el-radio", { attrs: { label: "private" } }, [
                  _vm._v("Private (only me)"),
                ]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: "organisation" } }, [
                  _vm._v("Organisation"),
                ]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: "public" } }, [
                  _vm._v("Public (anyone with link)"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "viq-share__field" },
          [
            _c("label", [_vm._v("Expiry")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "Select expiry" },
                model: {
                  value: _vm.expiry,
                  callback: function ($$v) {
                    _vm.expiry = $$v
                  },
                  expression: "expiry",
                },
              },
              [
                _c("el-option", { attrs: { label: "Never", value: "never" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "24 hours", value: "24h" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "7 days", value: "7d" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "30 days", value: "30d" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "90 days", value: "90d" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "viq-share__field" },
          [
            _c("label", [_vm._v("Auto-refresh")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "Select frequency" },
                model: {
                  value: _vm.refreshFrequency,
                  callback: function ($$v) {
                    _vm.refreshFrequency = $$v
                  },
                  expression: "refreshFrequency",
                },
              },
              [
                _c("el-option", { attrs: { label: "None", value: "none" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "Daily", value: "daily" } }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "Weekly", value: "weekly" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "Monthly", value: "monthly" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.shareLink
          ? _c("div", { staticClass: "viq-share__link" }, [
              _c("label", [_vm._v("Share Link")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viq-share__link-row" },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.shareLink,
                      readonly: "",
                      size: "small",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.copyLink } },
                    [_vm._v("Copy")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.embedCode
          ? _c(
              "div",
              { staticClass: "viq-share__embed" },
              [
                _c("label", [_vm._v("Embed Code")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    value: _vm.embedCode,
                    readonly: "",
                    type: "textarea",
                    rows: 3,
                    size: "small",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.save },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.shareLink ? "Update" : "Save & Generate Link") +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }